















import { Vue, Component } from "vue-property-decorator";
import VModal from "vue-js-modal";
import Loading from "vue-loading-overlay";
import JJRiskChartView from "./JJRiskChartView.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import "@/css/common.css";

Vue.use(VModal, { dialog: true });
Vue.use(Loading);

@Component({
  components: {
    JJRiskChartView,
  },
})
export default class DiabetesRiskMainVue extends Vue {
  loading = true;
  activeTab = "1";
  width = window.innerWidth;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get refs(): any {
    return this.$refs;
  }

  constructor() {
    super();
    window.addEventListener("resize", this.onResized);
  }

  onResized() {
    this.width = window.innerWidth;
  }
}
